import React from "react";
import { SvgIcon } from "e100-react-components";
import { IProps } from "e100-react-components/lib/components/SvgIcon/index";

export const Star = (props: IProps) => (
  <SvgIcon {...props}>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M7.00065 10.847L11.1207 13.3337L10.0273 8.64699L13.6673 5.49366L8.87399 5.08699L7.00065 0.666992L5.12732 5.08699L0.333984 5.49366L3.97398 8.64699L2.88065 13.3337L7.00065 10.847Z"
    />
  </SvgIcon>
);
